function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(overlay, image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnifyOnHover(image, zoomRatio) {
  // Es gibt zu jedem Zeitpunkt hoechstens ein aktives Overlay pro Bild.
  let overlay = null;

  const removeOverlay = () => {
    if (overlay) {
      overlay.remove();
      overlay = null;
    }
  };

  // mouseenter statt mouseover: feuert nur beim Betreten, nicht fuer jedes
  // Kind-Element -> keine gestapelten Overlays.
  image.addEventListener('mouseenter', (event) => {
    // Evtl. noch vorhandenes Overlay zuerst entfernen.
    removeOverlay();

    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('src', `${image.src}`);

    const el = document.createElement('div');
    prepareOverlay(el, overlayImage);
    overlay = el;

    moveWithHover(el, image, event, zoomRatio);
    el.onmousemove = (e) => moveWithHover(el, image, e, zoomRatio);
    el.onmouseleave = removeOverlay;

    overlayImage.onload = () => {
      // WICHTIG: Nur einhaengen, wenn dieses Overlay noch das aktive ist.
      // Faehrt der Cursor weg, bevor das Bild geladen ist, wurde overlay per
      // removeOverlay() bereits auf null gesetzt -> kein nachtraegliches
      // Einhaengen mehr, sonst bliebe der Zoom haengen.
      if (overlay === el && !el.parentElement) {
        image.parentElement.insertBefore(el, image);
      }
    };
  });

  // Sicherheitsnetz: verlaesst der Cursor das Bild, Overlay weg.
  // ABER: Sobald das Overlay ueber dem Bild liegt, ist es das oberste Element
  // -> der Browser feuert mouseleave auf dem Bild, obwohl der Cursor noch im
  // Bildbereich ist (Wechsel Bild -> Overlay). Diesen Uebergang ignorieren wir
  // anhand von relatedTarget, sonst wuerde das Overlay sofort wieder entfernt
  // und es gaebe gar keinen Zoom mehr.
  image.addEventListener('mouseleave', (e) => {
    const to = e.relatedTarget;
    if (overlay && (to === overlay || (overlay.contains && overlay.contains(to)))) {
      return;
    }
    removeOverlay();
  });
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    magnifyOnHover(image, zoomRatio);
  });
}

enableZoomOnHover(2);
